import { Button, Flex } from "@aws-amplify/ui-react";
import { MyIcon } from "../../ui-components";

export default function ({ iconType, label, onClick }) {
  return (
    <Flex gap="3px" direction="row" alignItems="center">
      <Flex
        borderRadius="4px"
        padding="6px"
        backgroundColor="rgba(233,249,252,1)"
      >
        <MyIcon type={iconType}></MyIcon>
      </Flex>
      <Button
        padding="6px"
        size="small"
        variation="link"
        children={label}
        onClick={onClick}
      ></Button>
    </Flex>
  );
}
